export default "__VITE_ASSET__a95Dn8yX__"